"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSession = exports.PaymentStatus = exports.PaymentProvider = void 0;
const class_transformer_1 = require("class-transformer");
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../../data-ui");
const layouts_1 = require("../../data-ui/layouts");
const column_numeric_transformer_1 = require("../../transformers/column-numeric-transformer");
const contact_profile_enum_1 = require("../contact-profile-enum");
const payment_address_1 = require("./payment-address");
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["KLARNA"] = "klarna";
    PaymentProvider["SOFORT"] = "sofort";
    PaymentProvider["STRIPE"] = "stripe";
})(PaymentProvider = exports.PaymentProvider || (exports.PaymentProvider = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["REJECTED"] = "rejected";
    PaymentStatus["ACCEPTED"] = "accepted";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
let PaymentSession = class PaymentSession {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        unique: true,
    }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Generated)('uuid'),
    __metadata("design:type", String)
], PaymentSession.prototype, "uuid", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        nullable: true,
        name: 'job_api_id',
        length: 255,
    }),
    (0, typeorm_1.Index)(),
    __metadata("design:type", String)
], PaymentSession.prototype, "jobApiId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Column)('character varying', {
        name: 'user_id',
        length: 32,
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "user", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(PaymentProvider),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: PaymentProvider,
        name: 'payment_provider',
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "provider", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.EnumValues(PaymentStatus),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: PaymentStatus,
        default: PaymentStatus.PENDING,
        name: 'payment_status',
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "status", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'payment_reference',
        length: 64,
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "paymentReference", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        name: 'redirect_url',
        length: 2048,
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "redirectURL", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('character varying', {
        default: 'DE',
        length: 2,
        name: 'country',
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "country", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('character varying', {
        default: 'DE',
        length: 3,
        name: 'currency',
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "currency", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('character varying', {
        default: 'DE',
        length: 5,
        name: 'locale',
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "locale", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('numeric', {
        name: 'total',
        precision: 12,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], PaymentSession.prototype, "total", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('numeric', {
        name: 'tax',
        precision: 12,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], PaymentSession.prototype, "tax", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('json', {
        nullable: true,
        name: 'provider_json',
        transformer: {
            to(value) {
                return value;
            },
            from(value) {
                return JSON.parse(value);
            },
        },
    }),
    __metadata("design:type", Object)
], PaymentSession.prototype, "providerData", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 64,
        name: 'reference',
    }),
    __metadata("design:type", String)
], PaymentSession.prototype, "reference", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.Override({ label: 'Already Paid' }),
    (0, typeorm_1.Column)('numeric', {
        name: 'already_paid',
        precision: 12,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
        default: 0,
    }),
    __metadata("design:type", Number)
], PaymentSession.prototype, "alreadyPaid", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.Override({ label: 'Amount To Pay' }),
    (0, typeorm_1.Column)('numeric', {
        name: 'amount_to_pay',
        precision: 12,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], PaymentSession.prototype, "amountToPay", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
        name: 'created_at',
    }),
    __metadata("design:type", Date)
], PaymentSession.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
        name: 'updated_at',
    }),
    __metadata("design:type", Date)
], PaymentSession.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => payment_address_1.PaymentAddress, { cascade: true }),
    (0, typeorm_1.JoinColumn)({ name: 'billing_address_id' }),
    __metadata("design:type", payment_address_1.PaymentAddress)
], PaymentSession.prototype, "billingAddress", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => payment_address_1.PaymentAddress, { cascade: true }),
    (0, typeorm_1.JoinColumn)({ name: 'shipping_address_id' }),
    __metadata("design:type", payment_address_1.PaymentAddress)
], PaymentSession.prototype, "shippingAddress", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.Override({ generated: true }),
    __metadata("design:type", Array)
], PaymentSession.prototype, "items", void 0);
PaymentSession = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [],
    }),
    data_ui_1.DataUi.Name({
        name: 'Payment Session',
        nameProperties: ['uuid'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('payment_session', { schema: 'payment' })
], PaymentSession);
exports.PaymentSession = PaymentSession;
//# sourceMappingURL=payment-session.js.map